import { HOME_VIEWS, getHomeView } from "./utils/get-home-view";
import DefaultHome from "./views/default-home";
import FranchiseMarketingHome from "./franchise-marketing/page";

const HOME_VIEW_COMPONENTS = {
  [HOME_VIEWS.FRANCHISE_MARKETING]: FranchiseMarketingHome,
  [HOME_VIEWS.DEFAULT]: DefaultHome,
};

export default function Home() {
  const userDetail = JSON.parse(localStorage.getItem("userDetail") || "null");
  const viewKey = getHomeView(userDetail);
  const ViewComponent = HOME_VIEW_COMPONENTS[viewKey];

  return <ViewComponent />;
}
